import React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';



const OrderGuideWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: inherit;
    height: auto;  
    padding-top: 20rem;
    padding-bottom: 15rem;
    position: relative;
    align-items: center;
    text-align: center;

    .wave-one{
        background-image: url('/page-decor/product-top-wave.png');
        background-repeat: no-repeat;
        background-position-x: right;
        background-position-y: top;
        position: absolute;
        width: 100vw;
        height: 12vh;
        top: 25%;
    }
    .wave-two{
        background-image: url('/page-decor/product-bottom-wave.png');
        background-repeat: no-repeat;
        background-position-x: left;
        background-position-y: bottom;
        position: absolute;
        width: 110vw;
        height: 12vh;
        bottom: 25%;
    }
`;

const TextContainer = styled.div`
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 40px;
    line-height: 50px;
    /* or 125% */
    text-align: center;
    max-width: 50rem;
    color: var(--color-gray-700);
    padding-bottom: var(--space-24);

    @media only screen and (max-width: 500px){
        font-size: 25px;
    }
`;

const SubTextContainer = styled.div`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    /* identical to box height, or 160% */


    /* default/gray/600 */

    color: var(--color-gray-600);
    padding-bottom: var(--space-48);
`;

const HeaderButton = styled.div`
    display: flex;
    position: relative;
    padding: 2rem;

    .contact--btn{
        max-width: 20rem;
        z-index: 3;
        color: var(--color-white);
        padding: 17px 32px;
        background-color: var(--hero-button);
        box-shadow: 0px 2px 6px rgba(16, 216, 197, 0.16), 0px 6px 15px rgba(16, 216, 197, 0.34);
        border-radius: 2.75rem;
        
        /* padding: 0;
        margin: 0; */
        
        font-size: 1rem;
        font-weight: 500;
        font-family: Inter, sans-serif;
        
        transition: all 1s;
        position: relative;
    }
`;
export function OrderGuide() {
    return (
        <OrderGuideWrapper>
            <div className="wave-one"></div>
            <TextContainer>Access premium products and lower wait time for prescription refills</TextContainer>
            <SubTextContainer>Registering is quick and easy, it only takes 2 minutes!</SubTextContainer>
            <HeaderButton>
                <Link to={"/login"}><button type className="contact--btn">Register Now</button></Link>
            </HeaderButton>
            <div className="wave-two"></div>
        </OrderGuideWrapper>
    );
}